/* eslint-disable import/no-unresolved */
const constants = require('onestic-base/constants');
const slickSlider = require('onestic-base/components/slider');
const utils = require('onestic-base/utils');

const runSlick = (element) => {
    const { prev, next } = utils.getSliderLabels();
    slickSlider.methods.useCustomizableSlick(
        element,
        true,
		`<button type="button" class="icon-left-arrow-line next no-btn" aria-label="${prev}"></button>`,
		`<button type="button" class="icon-right-arrow-line prev no-btn" aria-label="${next}"></button>`,
        4,
        {
            arrows: true,
            infinite: false,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: constants.viewport_bootstrap.md,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                    },
                },
                {
                    breakpoint: constants.viewport_bootstrap.lg,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                    },
                },
            ],
        },
    );
};

// eslint-disable-next-line consistent-return
const checkElement = (selector, fn) => {
    if ($(selector).length) {
        fn();
        return;
    }
    setTimeout(() => {
        checkElement(selector, fn);
    }, 100);
};

const refreshCarousel = (carouselToShow) => {
    const carouselInitialized = $(carouselToShow);
    setTimeout(() => {
        carouselInitialized.slick('refresh');
    }, 300);
};

const slickConfig = () => {
    checkElement('.product-carousel', runSlick.bind(null, '.product-carousel'));
};

/**
 * Update Product Carousel Callout Title link
 * @param {element} carousel - Product carousel
 * @param {element} tabsCalloutLink - Link element
 */
function updateCarouselTitleLink(carousel, tabsCalloutLink) {
    const calloutLink = carousel.find('.carousel-button a');
    if (calloutLink.length) {
        const parentTitleLink = calloutLink.attr('href');
        if (parentTitleLink.toString() !== 'undefined') {
            tabsCalloutLink.attr('href', parentTitleLink);
        }
    } else {
        tabsCalloutLink.attr('href', '');
    }
}

const featuredTabs = () => {
    const tabsContainer = $('.featuredProduct-container');
    const currentTab = $('.featuredProduct-container .current-tab');
    const tabsCalloutLink = tabsContainer.find('.tabs-title-link');

    if (tabsContainer.length) {
        const navTabs = tabsContainer.find('.nav-tabs');
        const tabs = tabsContainer.find('.tab-pane');

        tabsCalloutLink.on('click', (e) => {
            const thisTarget = $(e.currentTarget);
            if (thisTarget.attr('href').toString() === '') {
                e.preventDefault();
            }
        });

        tabs.each((i, element) => {
            const thisTarget = $(element);
            const tabID = thisTarget.find('.featured-carousel-inner').data('id');
            const tabTitle = thisTarget.find('.featured-carousel-inner').data('title');
            const calloutMessage = thisTarget.find('.callout-slot');
            const navItem = `<li class="nav-item"><a data-text="${tabTitle}" data-toggle="tab" class="nav-link" href="#${tabID}">${tabTitle}</a>`;

            thisTarget.attr('id', tabID);
            navTabs.append(navItem);

            if (i === 0) {
                thisTarget.find('.tab-pane').addClass('in active');
                navTabs.find('.nav-item a').addClass('active');
                currentTab.find('.current-tab-label').text(thisTarget.find('.heading1').text());

                updateCarouselTitleLink(thisTarget, tabsCalloutLink);

                if (calloutMessage.length) {
                    $('.tabs-container .heading1').text(calloutMessage.val());
                }
            }
        });

        navTabs.addClass('active');

        const tabsItem = navTabs.find('.nav-item');
        tabsItem.on('click', (e) => {
            const element = $(e.currentTarget);
            const elementParent = element.parents('.featuredProduct-container');
            const activeTab = `${element.find('a').attr('href')}`;
            const currentCarousel = elementParent.find(`${activeTab}`);
            const noCurrentCarousels = $('.featuredProduct-container .featured-carousel-container').not(currentCarousel);
            const tabTitle = elementParent.find(`${activeTab} .callout-slot`);
            elementParent.find('.current-tab-label').text(`${element.find('a').text()}`);

            if (tabTitle.length) {
                updateCarouselTitleLink(currentCarousel, tabsCalloutLink);
                element.parents('.featuredProduct-container').find('.tabs-container .heading1').text(tabTitle.val());
            }

            noCurrentCarousels.removeClass('active in');
            currentCarousel.addClass('active in');

            refreshCarousel(`.featuredProduct-container ${activeTab} .product-carousel`);

            if (window.innerWidth < constants.viewport_bootstrap.lg) {
                currentTab.trigger('click');
            }
        });

        currentTab.on('click', (e) => {
            const thisTarget = $(e.currentTarget);
            navTabs.slideToggle('fast');
            thisTarget.find('.icon-down-arrow-line').toggleClass('open');
            thisTarget.toggleClass('active');
        });
    }
};

export default () => {
    featuredTabs();

    setTimeout(() => {
        slickConfig();
    }, 2000);
};
